// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"70599fc2","124":"7d299434","185":"7bdc30af","353":"14d7ae96","660":"dff304d2","697":"58e6a9ad","712":"d7865664","767":"0aa2f9da","819":"f3a50485","926":"50a44260"}[chunkId] + ".chunk.js";
};